var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.question.cssClasses.selectWrapper, on: { click: _vm.click } },
    [
      !_vm.question.isReadOnly
        ? _c(
            "div",
            {
              class: _vm.question.getControlClass(),
              attrs: {
                id: _vm.question.inputId,
                tabindex: _vm.model.noTabIndex ? undefined : 0,
                disabled: _vm.question.isDisabledAttr,
                role: _vm.question.ariaRole,
                "aria-required": _vm.question.ariaRequired,
                "aria-label": _vm.question.ariaLabel,
                "aria-invalid": _vm.question.ariaInvalid,
                "aria-errormessage": _vm.question.ariaErrormessage,
                "aria-expanded": _vm.question.ariaExpanded,
                "aria-controls": _vm.model.listElementId,
                "aria-activedescendant": _vm.model.ariaActivedescendant,
                required: _vm.question.isRequired,
              },
              on: { keydown: _vm.keyhandler, blur: _vm.blur },
            },
            [
              _c(
                "div",
                { class: _vm.question.cssClasses.controlValue },
                [
                  _vm._l(_vm.selectedChoices, function (item, index) {
                    return _c("sv-tagbox-item", {
                      key: "item" + index,
                      attrs: { item: item, question: _vm.question },
                    })
                  }),
                  _vm._v(" "),
                  _c("sv-tagbox-filter", {
                    attrs: { model: _vm.model, question: _vm.question },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _vm.question.allowClear &&
              _vm.question.cssClasses.cleanButtonIconId
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.question.showClearButton,
                          expression: "question.showClearButton",
                        },
                      ],
                      class: _vm.question.cssClasses.cleanButton,
                      attrs: { "aria-hidden": "true" },
                      on: { click: _vm.clear },
                    },
                    [
                      _c("sv-svg-icon", {
                        class: _vm.question.cssClasses.cleanButtonSvg,
                        attrs: {
                          iconName: _vm.question.cssClasses.cleanButtonIconId,
                          title: _vm.question.clearCaption,
                          size: "auto",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.question.isReadOnly
        ? _c("sv-popup", { attrs: { model: _vm.model.popupModel } })
        : _c(
            "div",
            {
              class: _vm.question.getControlClass(),
              attrs: {
                id: _vm.question.inputId,
                "aria-label": _vm.question.a11y_input_ariaLabel,
                "aria-labelledby": _vm.question.a11y_input_ariaLabelledBy,
                "aria-describedby": _vm.question.a11y_input_ariaDescribedBy,
                tabindex: _vm.model.isDisabledAttr ? undefined : 0,
              },
            },
            [
              _vm.question.locReadOnlyText
                ? _c("survey-string", {
                    attrs: { locString: _vm.question.locReadOnlyText },
                  })
                : _vm._e(),
            ],
            1
          ),
      _vm._v(" "),
      _vm.question.cssClasses.chevronButtonIconId
        ? _c(
            "div",
            {
              class: _vm.question.cssClasses.chevronButton,
              attrs: { "aria-hidden": "true" },
              on: { pointerdown: _vm.chevronPointerDown },
            },
            [
              _c("sv-svg-icon", {
                class: _vm.question.cssClasses.chevronButtonSvg,
                attrs: {
                  iconName: _vm.question.cssClasses.chevronButtonIconId,
                  size: "auto",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }